import getApolloClient from './apolloClient'
import gql from 'graphql-tag'
import Vue from 'vue'
import request from './request'
import axios from 'axios'

const way =  './graphql/stop lists/'

export default class StopListApi {

  async getHeaders(type) {
    const token = await Vue.prototype.$auth.getUserToken()
    const headers = {
      'Content-Type': type || 'multipart/form-data',
      'Authorization': `Bearer ${token ? token : ''}`,
      'Auth-Provider': 'SmartId',
      'OrganizationItId': sessionStorage.getItem('OrganizationItId'),
      'Access-Control-Allow-Headers': '*',
      'Access-Control-Allow-Origin': '*',
      'culture': sessionStorage.language,
      'accept-language': sessionStorage.language,
      'href': window.location.href,
    }
    if (crypto?.randomUUID)  {
      headers.correlationId = crypto.randomUUID()
    }
    const user = (await Vue.prototype.$auth.getUser())
    let my_local = localStorage.getObject(`${(user.profile.preferred_username || '').toLowerCase()}_settings`),
      GodMode = my_local && my_local.GodMode
    if (GodMode) {
      headers.GodMode = +GodMode
    }
    return headers
  }

  async getStopListByCurrentOrganization() {
    let getStopList   = await import(way + 'getStopListByCurrentOrganization.gql')
    return (await getApolloClient('/tenders'))
      .query({
        query: gql`${ getStopList  }`,
      })
      .then(res => res?.data?.getStopListByCurrentOrganization)
      .catch(error => Vue.prototype.$log_error(error.message))
  }

  async getStopListByOkpo({okpo, orgId}) {
    let getStopList   = await import(way + 'getStopListByOkpo.gql')
    return (await getApolloClient('/tenders'))
      .query({
        query: gql`${ getStopList  }`,
        variables: { okpo, orgId }
      })
      .then(res => res?.data?.getStopListByOkpo)
      .catch(error => Vue.prototype.$log_error(error.message))
  }

  async getMyOrganizationList() {
    let getMyOrganizationList   = await import(way + 'getMyOrganizationList.gql')
    return (await getApolloClient('/tenders'))
      .query({
        query: gql`${ getMyOrganizationList  }`,
      })
      .then(res => res?.data?.getMyOrganizationList)
      .catch(error => Vue.prototype.$log_error(error.message))
  }

  async getOrganizationInfo(okpo) {
    let getOrganizationInfo   = await import(way + 'getOrganizationInfo.gql')
    return (await getApolloClient('/tenders'))
      .query({
        query: gql`${ getOrganizationInfo  }`,
        variables: { okpo }
      })
      .then(res => res?.data?.getOrganizationInfo)
      .catch(error => Vue.prototype.$log_error(error.message))
  }


  // mutations

  async addToStopList( model , files) {

    const getGqlString = (doc) => {
      return doc.loc && doc.loc.source.body
    }

    if (!files?.length) {
      return await request({
        environment: '/tenders',
        type: 'mutation',
        name: 'addToStopList',
        variables: { model,files: null },
        way
      })
    }

    let addToStopList = await import(way + 'addToStopList.gql')
    let formdata = new FormData()

    const query = {
      query: getGqlString(gql`${addToStopList}`),
      variables: { model , files: new Array(files.length) },
      operationName: null
    }
    let mapdata = {}
    formdata.append('operations', JSON.stringify(query))

    files.forEach((file, index) => {
      formdata.append(index, file, file.name)
      mapdata[index] = ['variables.files.' + index ]
    })

    formdata.append('map', JSON.stringify(mapdata))
    const uri = window.config.GrapgQlUrl + '/tenders'
    return await axios.post(uri, formdata,
      {
        headers: await this.getHeaders(),
        onUploadProgress: this.listener
      })
      .then((res) => {
        if (res.data?.data?.addToStopList) {
          return res.data?.data?.addToStopList
        } else {
          throw {
            graphQLErrors: res.data?.errors
          }
        }

      })
      .catch(async (error) => {
        throw error
      })

  }

  async unlockInStopListByOrganizer(unlockStopList) {
    let unlockInStopListByOrganizer  = await import(way + 'unlockInStopListByOrganizer.gql')
    return (await getApolloClient('/tenders'))
      .mutate({
        mutation: gql`${ unlockInStopListByOrganizer }`,
        variables: { unlockStopList }
      })
      .then(res => res.data.unlockInStopListByOrganizer)
  }
  async unlockInStopList( unlockStopList ) {
    let unlockInStopList  = await import(way + 'unlockInStopList.gql')
    return (await getApolloClient('/tenders'))
      .mutate({
        mutation: gql`${ unlockInStopList }`,
        variables: { unlockStopList }
      })
      .then(res => res.data.unlockInStopList)
      // .catch(error => Vue.prototype.$log_error(error.message))
  }

  async childListOrganizators() {
    let childListOrganizators   = await import(way + 'childListOrganizators.gql')
    return (await getApolloClient('/tenders'))
      .query({
        query: gql`${ childListOrganizators  }`,
      })
      .then(res => res?.data?.childListOrgnizators)
      .catch(error => Vue.prototype.$log_error(error.message))
  }
}
